import { fastApi } from "@/redux/api/fastApi";

export interface AddVideoPayload {
  reference_video_url: string;
  product_image_url: string;
  prompt_brief: string;
}

export interface GeneratedVideoResponse {
  job_id: string;
}

const videoGeneration = fastApi.injectEndpoints({
  endpoints: (builder) => ({
    // POST /video-generation/generate
    addVideo: builder.mutation<GeneratedVideoResponse, AddVideoPayload>({
      query: (payload) => ({
        url: `/video-generation/generate`,
        method: "POST",
        body: payload,
      }),
    }),

    // GET /video-generation/download/:id
    getGeneratedVideo: builder.query<GeneratedVideoResponse, string>({
      query: (id) => ({
        url: `/video-generation/download/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useAddVideoMutation, useGetGeneratedVideoQuery } =
  videoGeneration;
